import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import CookieBanner from './components/CookieBanner';
import Home from './pages/Home';
import Tools from './pages/Tools';
import AIHeadhunter from './pages/AIHeadhunter';
import Mogelijkheden from './pages/Mogelijkheden';
import Platforms from './pages/Platforms';
import Visie from './pages/Visie';
import VacatureMatch from './pages/tools/VacatureMatch';
import Motivatiebrief from './pages/tools/Motivatiebrief';
import LinkedInCheck from './pages/tools/LinkedInCheck';
import GesprekTrainer from './pages/tools/GesprekTrainer';
import Over from './pages/Over';
import Contact from './pages/Contact';
import Privacy from './pages/Privacy';
import Cookies from './pages/Cookies';
import Terms from './pages/Terms';
import StrategicOverview from './pages/StrategicOverview';
import { LanguageProvider } from './context/LanguageContext';

function App() {
  return (
    <LanguageProvider>
      <div className="min-h-screen bg-white font-inter">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/ai-headhunter" element={<AIHeadhunter />} />
            <Route path="/mogelijkheden" element={<Mogelijkheden />} />
            <Route path="/tools" element={<Tools />} />
            <Route path="/platforms" element={<Platforms />} />
            <Route path="/visie" element={<Visie />} />
            <Route path="/tools/vacature-match" element={<VacatureMatch />} />
            <Route path="/tools/motivatiebrief" element={<Motivatiebrief />} />
            <Route path="/tools/linkedin-check" element={<LinkedInCheck />} />
            <Route path="/tools/gesprek-trainer" element={<GesprekTrainer />} />
            <Route path="/over" element={<Over />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/cookies" element={<Cookies />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/methodiek" element={<StrategicOverview />} />
          </Routes>
        </main>
        <Footer />
        <CookieBanner />
      </div>
    </LanguageProvider>
  );
}

export default App;